import { Carousel } from "react-bootstrap";
import f1 from "../../assets/img/goals/1.png";
import f2 from "../../assets/img/goals/2.png";
import f3 from "../../assets/img/goals/3.png";
import f4 from "../../assets/img/goals/4.png";
import ny from "../../assets/img/goals/ny.png";

export default function Home() {
  return (
    <div>
      <Carousel>
        <Carousel.Item className="text-center">
          <img src={ny} width="100%" />
        </Carousel.Item>
        {/* <Carousel.Item className="text-center">
          <img src={f4} width="90%" />
        </Carousel.Item>
        <Carousel.Item className="text-center">
          <img src={f1} width="90%" />
        </Carousel.Item>
        <Carousel.Item className="text-center">
          <img src={f2} width="90%" />
        </Carousel.Item>
        <Carousel.Item className="text-center">
          <img src={f3} width="90%" />
        </Carousel.Item> */}
      </Carousel>
    </div>
  );
}
